'use client';
import cn from 'classnames';

import Link from '@/components/common/Link/Link';
import Text from '@/components/common/Text/Text';

import { useOnMount } from '@/components/hook/onMount';

import analytics from '@/util/analytics';
import { ACCOUNT_SECTION } from '@/types/Account';

import './PastDueBanner.style.scss';
import { useContextBroker } from '@/components/context/ContextBroker/useContextBroker';

type PastDueBannerProps = {
  className?: string;
};

function PastDueBanner(props: PastDueBannerProps) {
  const { className = '' } = props;
  const { isIOSWebView } = useContextBroker();
  const handleBannerClickAnalytics = () => {
    analytics.track('Past Due Subscription Banner - Clicked');
  };
  let accountUrl;

  useOnMount(() => {
    analytics.track('Past Due Subscription Banner - Viewed');
  });

  if (isIOSWebView) {
    accountUrl = '/myaccount/payment';
  } else {
    accountUrl = `/account?section=${ACCOUNT_SECTION.PAYMENT}&editSection=payment`;
  }

  return (
    <div className={cn('PastDueBanner', className)}>
      <Text variant='title-xs'>
        Your account is Past Due. To continue using your membership, please{' '}
        <Link
          href={accountUrl}
          compact
          underline
          variant='link-l'
          onClick={handleBannerClickAnalytics}
        >
          update your Payment Details.
        </Link>
      </Text>
    </div>
  );
}

export default PastDueBanner;
